import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesEyeOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M11.333 11.417c.938 0 1.25.625 1.25 1.25s-.313 1.25-1.25 1.25-1.25-.625-1.25-1.25.313-1.25 1.25-1.25"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.333 9.333c2.333 0 4.472 2.499 4.667 3.333-.194.833-2.334 3.334-4.667 3.334l-.218-.008c-2.247-.147-4.26-2.519-4.448-3.326.19-.808 2.202-3.179 4.448-3.326zm0 1.4c-.688 0-1.49.39-2.224 1.017-.349.3-.638.617-.84.886l-.022.03.022.031c.202.27.491.587.84.886.733.628 1.535 1.017 2.224 1.017s1.492-.389 2.225-1.017c.349-.3.637-.617.84-.886l.022-.031-.022-.03a5.8 5.8 0 0 0-.84-.886c-.733-.628-1.536-1.017-2.225-1.017"
                fill="currentColor"
            />
            <path
                d="M8 1c6.563 0 7.5.875 7.5 7q-.001.345-.007.667h-1.401q.006-.32.008-.667c0-1.52-.06-2.603-.221-3.4-.157-.777-.384-1.15-.623-1.373-.25-.234-.683-.462-1.558-.616-.882-.155-2.067-.21-3.698-.21s-2.816.055-3.698.21c-.875.154-1.308.382-1.558.616-.24.223-.466.596-.623 1.373-.16.797-.22 1.88-.22 3.4s.06 2.603.22 3.4c.157.777.384 1.15.623 1.373.25.234.683.462 1.558.616q.456.079 1.031.126v1.404C1.169 14.6.5 13.174.5 8c0-6.125.938-7 7.5-7"
                fill="currentColor"
            />
            <path d="M8 8.7H4V7.3h4z" fill="currentColor" />
            <path d="M12 6.034H4v-1.4h8z" fill="currentColor" />
        </g>
    </svg>
));
CardLinesEyeOutlinedSize16Glyph.displayName = 'CardLinesEyeOutlinedSize16Glyph';
